import * as idEndpoints from './id';
import { root, id } from './regions';

export const regions = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
